import React, { useCallback } from 'react';

import { ExpanderOnChangeEvent } from 'src/components/sidebar';
import Expander, {
  ExpanderProps,
} from 'src/components/sidebar/src/expander/expander';
import { useMatch } from 'src/router/hooks';

import { useIsCardCollapsed } from '../hooks/sidebar-card-collapsed';

import { PR_PATH } from './constants';

type ConnectedExpanderProps = {
  localStorageKey: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ConnectedExpander: React.FC<
  ConnectedExpanderProps & Omit<ExpanderProps, 'isCollapsed'>
> = ({ localStorageKey, onChange, defaultIsCollapsed, ...rest }) => {
  const { isCardCollapsed, setIsCardCollapsed } = useIsCardCollapsed({
    localStorageKey,
    defaultIsCardCollapsed: defaultIsCollapsed,
  });

  const { path } = useMatch();
  // Use startsWith instead of exact match to handle /:pullRequestId and /:pullRequestId/overview
  const isPrPage = path.startsWith(PR_PATH);

  const newOnChange = useCallback(
    (e: ExpanderOnChangeEvent) => {
      if (onChange !== undefined) {
        onChange(e);
      }
      setIsCardCollapsed(e);
    },
    [onChange, setIsCardCollapsed]
  );

  return (
    <Expander
      isCollapsed={isCardCollapsed}
      onChange={newOnChange}
      localStorageKey={localStorageKey}
      isPrPage={isPrPage}
      {...rest}
    />
  );
};
